import { Box, useTheme } from '@mui/material';
import React from 'react';

export interface CardDividerProps {
  lineColor?: string;
  margin?: boolean;
  text?: React.ReactNode;
}

/**
 * A fine grey line with an optional text in its center
 * @returns {component} Component
 */
const CardDivider = (props: CardDividerProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: props.lineColor ?? theme.palette.grey.xLight,
        display: 'flex',
        height: '2px',
        justifyContent: 'center',
        marginBottom: props.margin ? '1em' : undefined,
        width: '100%',
      }}
    >
      {props.text && (
        <Box
          component="span"
          sx={{
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightBold,
            padding: '0 7px',
            zIndex: 1,
          }}
        >
          {props.text}
        </Box>
      )}
    </Box>
  );
};

export default CardDivider;
